import { orderStatus, getOrderById } from 'shared/models/api';

export const LOAD_LIVE_ORDER = 'LOAD_LIVE_ORDER';
export const LIVE_ORDER_LOADING = 'LIVE_ORDER_LOADING';
export const LIVE_ORDER_ERROR = 'LIVE_ORDER_ERROR';
export const LIVE_ORDER_UPDATE_STATUS = 'LIVE_ORDER_UPDATE_STATUS';
export const LIVE_ORDER_UPDATE_ETA = 'LIVE_ORDER_UPDATE_ETA';
export const LIVE_ORDER_UPDATE_DRIVER = 'LIVE_ORDER_UPDATE_DRIVER';
export const LIVE_ORDER_UPDATE_TRACKING_STATE =
  'LIVE_ORDER_UPDATE_TRACKING_STATE';
export const TIP_STARTED = 'TIP_STARTED';

const init = {
  order: {},
  contactNumber: null,
  loading: false,
  tipStarted: false
};

export default function(state = init, action = {}) {
  switch (action.type) {
    case LOAD_LIVE_ORDER:
      return { ...state, order: action.order, loading: false };
    case LIVE_ORDER_LOADING:
      return { ...state, loading: true };
    case LIVE_ORDER_ERROR:
      return { ...state, loading: false };
    case LIVE_ORDER_UPDATE_STATUS:
      return {
        ...state,
        order: { ...state.order, order_status: action.order_status }
      };
    case LIVE_ORDER_UPDATE_ETA:
      return {
        ...state,
        order: {
          ...state.order,
          eta: {
            ...(state.order.eta || {}),
            ...action.eta
          }
        }
      };
    case LIVE_ORDER_UPDATE_DRIVER:
      return {
        ...state,
        order: {
          ...state.order,
          driver: {
            ...(state.order.driver || {}),
            ...action.driver
          }
        }
      };
    case LIVE_ORDER_UPDATE_TRACKING_STATE:
      return {
        ...state,
        order: {
          ...state.order,
          tracking_state: {
            ...(state.order.tracking_state || {}),
            ...action.tracking_state
          }
        }
      };
    case TIP_STARTED:
      return {
        ...state,
        tipStarted: true
      };
    default:
      return state;
  }
}

export function loadOrder(orderId) {
  return dispatch => {
    dispatch({ type: LIVE_ORDER_LOADING });
    return getOrderById(orderId)
      .then(order => {
        dispatch({ type: LOAD_LIVE_ORDER, order });
      })
      .catch(() => {
        dispatch({ type: LIVE_ORDER_ERROR });
      });
  };
}

export function refreshStatus(id) {
  return dispatch => {
    return orderStatus(id).then(result => {
      const { order_status, eta, driver, tracking_state } = result || {};
      if (typeof order_status !== 'undefined') {
        dispatch({ type: LIVE_ORDER_UPDATE_STATUS, order_status });
      }
      if (eta) dispatch({ type: LIVE_ORDER_UPDATE_ETA, eta });
      if (driver) dispatch({ type: LIVE_ORDER_UPDATE_DRIVER, driver });
      if (tracking_state)
        dispatch({ type: LIVE_ORDER_UPDATE_TRACKING_STATE, tracking_state });
    });
  };
}

export function tipStarted() {
  return dispatch => {
    dispatch({ type: TIP_STARTED });
  };
}
